module.exports = __webpack_public_path__ + "img/rapipago.6e604f9.svg";